import React, { useEffect, useMemo, useState } from 'react'
import { DetalleModificacionProyeccionHEDTO, DetalleServidoresProyHEDTO, InformacionProyeccionHEDirectivoUnidad, PersonalNoProyectadoDTO } from './TypesProyeccionDirectivo'
import { GuardarEnviarProyeccionTH, GuardarProyeccionParcialmente, ObtenerDetalleProyeccionPersonalDirectivoUnidad, ObtenerInformacionProyeccionDirectivoByAnio, ObtenerInformacionProyeccionDirectivoHE, ObtenerReporteExcelResumenProyeccionTH, SolicitarReversoProyeccion } from './FunctionsProyeccionDirectivoUnidad';
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';

import { Tab, Tabs } from 'react-bootstrap';
import { Row, Col, Button, Table, Input } from "reactstrap";

import Cargando from 'components/Varios/Cargando';
import ActividadProyeccionHE from './ActividadProyeccionHE';
import { DetalleActividadPlanHEDTO, SolicitudReversoDTO } from '../PlanificacionHE/TypesPlanificacionHE';
import ServidoresProyeccionHE from './ServidoresProyeccionHE';
import TabOtrasUnidades from './TabOtrasUnidades';
import ModalConfirmacionNew from 'components/Varios/Modals/ModalConfirmacionNew';

import SaveSVG from "./../../../../assets/icons/HorasExtras/Guardar.svg"
import CardRegimenHE from './CardRegimenHE';
import ModalReversoHE from 'components/Varios/Modals/ModalReversoHE';
import AlertEstadoHE from 'components/Varios/AlertEstadoHE';
import ModalCargando from 'components/Varios/ModalCargando';

import { classNameIconoFlechaRegresar } from 'constants/Icons-Font-Awesome';
import { useHistory, useLocation } from 'react-router';
import { ResponseRequestGeneric } from 'components/Types/GeneralTypes';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';



type ModalConfirmacionProyeccion = {
  showModal: boolean,
  solicitud: DetalleServidoresProyHEDTO[],
  content: HTMLElement | undefined
}

type ModalSolicitarReverso = {
  cargando: boolean,
  idProyeccionUnidad: number,
  observacion: string
}



interface LocationState {
  anio?: number;
}
export default function ProyeccionHE() {
  const location = useLocation();
  const { anio } = (location.state as LocationState) || {};
  const [informacionGeneralProyeccion, setinformacionGeneralProyeccion] = useState<InformacionProyeccionHEDirectivoUnidad | undefined>(undefined);

  const [listadoServyAct, setListadoServyAct] = useState<DetalleModificacionProyeccionHEDTO | null>()
  const [actividadSeleccionada, setActividadSeleccionada] = useState<DetalleActividadPlanHEDTO | undefined>(undefined);

  const [loading, setloading] = useState<boolean>(false)
  const [loadingActyServ, setloadingActyServ] = useState<boolean>(false)

  const [modalConfirmacionProyeccion, setModalConfirmacionProyeccion] = useState<ModalConfirmacionProyeccion | undefined>(undefined);
  const [modalConfirmacionEnvioTHProyeccion, setmodalConfirmacionEnvioTHProyeccion] = useState<ModalConfirmacionProyeccion | undefined>(undefined);
  const [modalSolicitarReverso, setmodalSolicitarReverso] = useState<ModalSolicitarReverso | undefined>(undefined)
  const [personalNoProyectado, setpersonalNoProyectado] = useState<PersonalNoProyectadoDTO[]>([])

  const [loadingAccion, setloadingAccion] = useState<boolean>(false)

  const [activeTab, setActiveTab] = useState<string | null>('Actividades');


  const [motivoReverso, setmotivoReverso] = useState<string>("")

  const history = useHistory();
  const TITULO_PANTALLA = "PROYECCIÓN ANUAL DE HORAS EXTRAS PARA EL AÑO " + (informacionGeneralProyeccion ? informacionGeneralProyeccion.anio.toString() : "")


  const ESTADOS_PARA_GUARDADO_PARCIAL: string[] = ['IN', 'RT', 'MO']
  const ESTADOS_PARA_ENVIAR_TH: string[] = ['IN', 'GP', 'RT', 'MO']

  async function ObtenerInformacion() {
    setloading(true)

    const anioNormalized = anio ?? 0
    var respuesta: ResponseRequestGeneric<InformacionProyeccionHEDirectivoUnidad | string> = {
      status: -1

    }

    if (anioNormalized == 0) {
      respuesta = await ObtenerInformacionProyeccionDirectivoHE();
    }
    else {
      respuesta = await ObtenerInformacionProyeccionDirectivoByAnio(anioNormalized);
    }


    if (respuesta.status === 200 && respuesta.dataResponse) {

      if (typeof (respuesta.dataResponse) === "string") {
        showAlert(respuesta.dataResponse, false);
      }
      else {
        setinformacionGeneralProyeccion(respuesta.dataResponse);
        setActividadSeleccionada(undefined)
      }

    }
    else if (respuesta.status === 401) {
      showAlert("Ud. no es usuario autorizado", false);
    }
    else {
      const mensajeDefault = "Ha ocurrido un inconveniente al tratar de obtener la información de la proyección de su unidad."
      showAlert(respuesta.errorMessage ?? mensajeDefault, false);
    }
    setloading(false)
  }


  async function ConsultarDetalleProyeccionesYActividades() {
    setloadingActyServ(true);

    const respuesta = await ObtenerDetalleProyeccionPersonalDirectivoUnidad();

    if (respuesta.status === 200 && respuesta.dataResponse) {

      setListadoServyAct(respuesta.dataResponse);

    } else {


      const mensajeDefault = "Ha ocurrido un inconveniente al tratar de obtener la información de la proyección de su unidad."
      showAlert(respuesta.errorMessage ?? mensajeDefault, false);

    }
    setloadingActyServ(false);
  }


  async function HandleGuardarProyeccion(proyeccion: DetalleServidoresProyHEDTO[]) {
    //const filtradosProyeccion = proyeccion.filter(servidor => servidor.estadoproyeccionpersonaunidad !== null && servidor.estadoproyeccionpersonaunidad.trim() === "IN");
    const result = await GuardarProyeccionParcialmente(proyeccion);

    if (result.status === 200) {
      showAlert("La proyección se ha guardado correctamente.", true);
      setModalConfirmacionProyeccion(undefined);
      ObtenerInformacion();
      return 1;
    } else {
      const messageDefault: string = "Ha ocurrido un evento inesperado."
      showAlert(result.errorMessage ?? messageDefault, false);
      setModalConfirmacionProyeccion(undefined);
      ObtenerInformacion();
      return -1;
    }
  }


  async function EnviarProyeccionaTH(proyeccion: DetalleServidoresProyHEDTO[]) {
    const result = await GuardarEnviarProyeccionTH(proyeccion);

    if (result.status === 200) {
      showAlert("La proyección ha sido enviada a TH.", true);
      setModalConfirmacionProyeccion(undefined);
      ObtenerInformacion(); return 1;
    } else {
      const messageDefault: string = "Ha ocurrido un evento inesperado."
      showAlert(result.errorMessage ?? messageDefault, false);
      setModalConfirmacionProyeccion(undefined);
      ObtenerInformacion();
      return -1;
    }
  }


  async function SolicitarReversoATH(idProyeccionUnidad: number, observacion: SolicitudReversoDTO) {
    const respuesta = await SolicitarReversoProyeccion(idProyeccionUnidad, observacion)
    if (respuesta.status === 200 || respuesta.status === 204) {
      showAlert("Se solicitó el reverso de la proyección correctamente.", true);
      await ObtenerInformacion();
    }
    else {

      const mensajeDefault = "Ha ocurrido un evento inesperado"
      showAlert(respuesta.errorMessage ?? mensajeDefault, false);
      await ObtenerInformacion();
    }
    return 1;
  }


  async function ReporteExcel() {
    setloadingAccion(true)
    await ObtenerReporteExcelResumenProyeccionTH()
    setloadingAccion(false)
  }

  function GetHTMLProyeccion(solicitud: DetalleServidoresProyHEDTO[], idEstructuraAprobacion: number): React.ReactNode {
    // Filtra los servidores con estado "IN"
    // const filtrados = solicitud.filter(servidor => servidor.estadoproyeccionpersonaunidad !== null && servidor.estadoproyeccionpersonaunidad.trim() === "IN");

    // Filtra las actividades por estructura y excluye los servidores sin actividades
    const servidoresConActividades = solicitud.map(servidor => {
      const actividadesFiltradas = servidor.actividadesplanificadas
        .filter(act => act.value.idEstructura === idEstructuraAprobacion);

      return {
        ...servidor,
        actividadesplanificadas: actividadesFiltradas
      };
    }).filter(servidor => servidor.actividadesplanificadas.length > 0); // Excluir servidores sin actividades

    const htmlRowsSolicitudes = (
      <>
        <Table responsive bordered className="table_planificacion_he">
          <thead className="cabeceras_tabla_planificacion_he">
            <tr className="borde_cabeceras_he">
              <th>N°</th>
              <th>Cédula</th>
              <th>Unidad</th>
              <th>Nombre Completo</th>
              <th>Actividades</th>
              <th>H. Suplem</th>
              <th>H. Extraord</th>
            </tr>
          </thead>
          <tbody>
            {servidoresConActividades.map((servidor, index) => (
              <tr key={servidor.idpersona} className={`rows_tabla_planificacion_he ${index % 2 === 0 ? 'even-row' : 'odd-row'}` }>
                <td>{index + 1}</td>
                <td>{servidor.identificacion}</td>
                <td>{servidor.nombreestructuraorganica}</td>
                <td>{servidor.nombrescompletos}</td>
                <td>
                  {servidor.actividadesplanificadas
                    .map(act => act.value.nombreActividad) // Mapea a los nombres de actividades
                    .join(', ')}
                </td>
                <td>
                    {servidor.horassuplementarias}
                </td>
                <td>
                    {servidor.horasextraordinarias}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );

    return htmlRowsSolicitudes;
  }

  function GetCuadroResumenAlEnviarTH(informacionGeneralProyeccion: InformacionProyeccionHEDirectivoUnidad) {
    return (
      <React.Fragment>
        <div className='textModalEnviarATH'>RESUMEN DE LA PROYECCIÓN ANUAL DE HORAS EXTRAS PARA EL AÑO {informacionGeneralProyeccion.anio.toString()}</div>
        <Table striped bordered>

          <thead>

          </thead>

          <tbody>
            {/* First row */}
            <tr style={{ backgroundColor: 'lightblue' }}>
              <td style={{ width: '60%' }}><strong>Número de servidores de la unidad</strong></td>
              <td style={{ width: '20%', textAlign: "center" }}>{informacionGeneralProyeccion.nroServidoresDeLaUnidad}</td>
              <td style={{ textAlign: "center" }}>{"Total de horas"}</td>
            </tr>
            {/* Middle row with extra cell */}
            <tr>
              <td><strong>Número de servidores incluidos en la proyección</strong></td>
              <td style={{ width: '20%', textAlign: "center" }}>{informacionGeneralProyeccion.nroServidoresProyectados}</td>
              <td style={{ border: '1px solid black', width: '20%', textAlign: "center" }}>{/* Solo muestra bordes para la segunda fila */}
                {informacionGeneralProyeccion.nroHorasProyectadas}
              </td>
            </tr>

            {/* Last row */}
            <tr style={{ backgroundColor: 'lightblue' }}>
              <td>  <strong>Número de servidores no incluidos en la proyección  </strong>
                {informacionGeneralProyeccion.nroServidoresNoProyectados > 0 &&
                  <span>
                    <a href='#'
                      onClick={(e) => {
                        e.preventDefault();
                        setpersonalNoProyectado(informacionGeneralProyeccion.personalNoProyectado)
                      }}>
                      {"(Ver lista)"}
                    </a>
                  </span>
                }
              </td>
              <td style={{ width: '20%', textAlign: "center" }}>{informacionGeneralProyeccion.nroServidoresNoProyectados}</td>
            </tr>
          </tbody>
        </Table>
        <div className='textModalEnviarAGPE'>¿DESEA ENVIAR A TALENTO HUMANO LA PROYECCIÓN ANUAL DE HORAS EXTRAS?</div>

      </React.Fragment>

    )
  }


  function GetHTMLPersonalNoProyectado(personal: PersonalNoProyectadoDTO[]) {
    if (personal.length > 0) {
      return (
        <Table responsive bordered className="table_planificacion_he">
          <thead className="cabeceras_tabla_planificacion_he">
            <tr className='borde_cabeceras_he'>
              <th>#</th>
              <th>NOMBRES</th>
              <th>CARGO</th>
              <th>REGIMEN</th>
            </tr>

          </thead>
          <tbody>
            {
              personal.map((v, i) => {

                // const styles:React.CSSProperties = i%2 == 0 ? { backgroundColor: 'lightblue' } : {}
                return (
                  <tr className="rows_tabla_planificacion_he" key={"trNoProyectado " + i}>
                    <td>{i + 1}</td>
                    <td >{v.nombrescompletos}</td>
                    <td>{v.cargo}</td>
                    <td >{v.nombreregimenlaboral}</td>

                  </tr>
                )
              })
            }

          </tbody>
        </Table>
      )
    }
    return (<div></div>)
  }

  const handleSubmit = (informacionGeneral: InformacionProyeccionHEDirectivoUnidad, detalleProyecciones: DetalleModificacionProyeccionHEDTO, idEstructuraAprobacion: number, tipo: "GP" | "ET") => {

    var proyecciones = [...detalleProyecciones.listadoServidores, ...detalleProyecciones.listadoServidoresOtrasUnidades]


    if (tipo === "GP") {

      proyecciones = proyecciones.filter(servidor => servidor.estadoproyeccionpersonaunidad && ESTADOS_PARA_GUARDADO_PARCIAL.includes(servidor.estadoproyeccionpersonaunidad.trim()));
      const content: any = GetHTMLProyeccion(proyecciones, idEstructuraAprobacion)
      setModalConfirmacionProyeccion(
        {
          showModal: true,
          solicitud: proyecciones,
          content
        })
    } else if (tipo === "ET") {
      proyecciones = proyecciones.filter(servidor => servidor.estadoproyeccionpersonaunidad && ESTADOS_PARA_ENVIAR_TH.includes(servidor.estadoproyeccionpersonaunidad.trim()));



      // const content: any = GetHTMLProyeccion(proyecciones, idEstructuraAprobacion)
      const content: any = GetCuadroResumenAlEnviarTH(informacionGeneral)
      setmodalConfirmacionEnvioTHProyeccion(
        {
          showModal: true,
          solicitud: proyecciones,
          content
        })


    } else {
      return;
    }




  };

  const handleSolicitarReverso = (idProyeccionUnidad: number) => {
    setmodalSolicitarReverso({
      cargando: false,
      idProyeccionUnidad: idProyeccionUnidad,
      observacion: ""

    })
  }






  const mostrarBotonGuardar = useMemo(() => {



    if (listadoServyAct && informacionGeneralProyeccion) {

      const tiposValidos: number[] = [0, 2]
      const esAprobadorTipo0 = tiposValidos.includes(informacionGeneralProyeccion.informacionAprobador.tipoAprobador) && !informacionGeneralProyeccion.mensajeError;
      const servidoresProy = listadoServyAct.listadoServidores.find(servidor => servidor.estadoproyeccionpersonaunidad && ESTADOS_PARA_GUARDADO_PARCIAL.includes(servidor.estadoproyeccionpersonaunidad.trim()));
      const servidoresProyOtrasUnidades = listadoServyAct.listadoServidoresOtrasUnidades.find(servidor => servidor.estadoproyeccionpersonaunidad && ESTADOS_PARA_GUARDADO_PARCIAL.includes(servidor.estadoproyeccionpersonaunidad.trim()));

      return (servidoresProy || servidoresProyOtrasUnidades) && esAprobadorTipo0;
    }


  }, [listadoServyAct?.listadoServidores, informacionGeneralProyeccion?.informacionAprobador.tipoAprobador]);


  const mostrarBotonFirmarEnviar = useMemo(() => {



    if (listadoServyAct && informacionGeneralProyeccion) {
      const tiposValidos: number[] = [1, 3]
      const esAprobadorTipo1 = tiposValidos.includes(informacionGeneralProyeccion.informacionAprobador.tipoAprobador) && !informacionGeneralProyeccion.mensajeError;
      const servidoresProy = listadoServyAct.listadoServidores.find(servidor => servidor.estadoproyeccionpersonaunidad && ESTADOS_PARA_ENVIAR_TH.includes(servidor.estadoproyeccionpersonaunidad.trim()));
      const servidoresProyOtrasUnidades = listadoServyAct.listadoServidoresOtrasUnidades.find(servidor => servidor.estadoproyeccionpersonaunidad && ESTADOS_PARA_ENVIAR_TH.includes(servidor.estadoproyeccionpersonaunidad.trim()));
      return (servidoresProy || servidoresProyOtrasUnidades) && esAprobadorTipo1;
    }

  }, [listadoServyAct?.listadoServidores, listadoServyAct?.listadoServidoresOtrasUnidades, informacionGeneralProyeccion?.informacionAprobador.tipoAprobador]);


  const mostrarBotonSolicitarReverso = useMemo(() => {

    const estadosConsiderar: string[] = ["SR"]

    if (listadoServyAct && informacionGeneralProyeccion) {
      const tiposValidos: number[] = [1, 3]
      const solicitudReverso = listadoServyAct.listadoServidores.find(servidor => servidor.estadoproyeccionpersonaunidad && estadosConsiderar.includes(servidor.estadoproyeccionpersonaunidad.trim()))
      const esAprobadorTipo1 = tiposValidos.includes(informacionGeneralProyeccion.informacionAprobador.tipoAprobador) && !informacionGeneralProyeccion.mensajeError;
      const servidoresProy = listadoServyAct.listadoServidores.find(servidor => servidor.estadoproyeccionpersonaunidad && (servidor.estadoproyeccionpersonaunidad.trim() === 'ET'))
      const servidoresProyOtrasUnidades = listadoServyAct.listadoServidoresOtrasUnidades.find(servidor => servidor.estadoproyeccionpersonaunidad && (servidor.estadoproyeccionpersonaunidad.trim() === 'ET'))

      return (servidoresProy || servidoresProyOtrasUnidades) && esAprobadorTipo1;
    }


  }, [listadoServyAct?.listadoServidores, listadoServyAct?.listadoServidoresOtrasUnidades, informacionGeneralProyeccion?.informacionAprobador.tipoAprobador, informacionGeneralProyeccion?.idSolReverso]);



  useEffect(() => {
    ObtenerInformacion();
  }, [])

  useEffect(() => {

    if (informacionGeneralProyeccion) {
      setListadoServyAct({
        listadoServidores: informacionGeneralProyeccion.listadoServidores,
        detalleActividadProyHEDTOs: informacionGeneralProyeccion.detalleActividadProyHEDTOs,
        listadoServidoresOtrasUnidades: informacionGeneralProyeccion.listadoServidoresOtrasUnidades
      });
    }

  }, [informacionGeneralProyeccion]);

  const contenidoModalReversarUnidad = useMemo(
    () => {
      if (modalSolicitarReverso !== undefined) {
        return (
          <React.Fragment>
            <Row>
              <Col xl={12}>
                <Row>
                  <Col xl={12}>
                    <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

                  </Col>
                  <Col xl={12}>
                    <Input
                      type="textarea"
                      name="motivoReversoUnidadProy"
                      id="motivoReversoUnidadProy"
                      value={motivoReverso}
                      onChange={(e) => setmotivoReverso(e.target.value)}
                    />
                  </Col>

                </Row>
              </Col>
            </Row>

          </React.Fragment>

        )
      }
      else {
        return (
          <div> No se ha seleccionado actividad para editar </div>
        )
      }
    },
    [motivoReverso, modalSolicitarReverso]
  )
  const handleGoBack = () => {
    //history.goBack(); // Esta función te lleva a la URL anterior
    history.push('/directivo/proyeccionHorasExtras/inicio')
  };

  const handleTabChange = (tab: string | null) => {
    setActiveTab(tab); // Actualiza la pestaña seleccionada
  };

  if (loading) {
    return (
      <div className='content'>
        <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div>
        <Cargando />
      </div>

    )

  }


  return (
    <div className='content'>
      {/* <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div> */}
      <div className="titulo_seccion mb-2"> <i className={`icono-flecha-regresar ${classNameIconoFlechaRegresar}`} onClick={handleGoBack} title='Regresar'></i> {TITULO_PANTALLA}</div>

      {loadingActyServ && <Cargando />}

      {
        !loadingActyServ &&
        <React.Fragment>


          {
            informacionGeneralProyeccion &&
            <Row className="justify-content-end">
              <Col md="auto">
                <AlertEstadoHE
                  estadoPlanificacion={informacionGeneralProyeccion.estadoProyUnidad.trim()}
                  oncloseElement={function (): void { ; }}
                  closeButton={false}
                  tipo='PR'
                  className="alert-lado-derecho"  // Añadir una clase personalizada si es necesario
                />
              </Col>
            </Row>
          }


          <Row className="row-no-margin">
            <Col xl={12} className="no-padding">
              <Row className="row-no-margin">
                {informacionGeneralProyeccion && informacionGeneralProyeccion.listadoProyeccionPorRegimenLaboral.map((regimen, index) => {
                  var className = ""
                  if (index === 0) { className = "no-padding-left-he" }
                  if (index === 2) { className = "no-padding-right-he" }
                  return (
                    <Col xl={4} key={index} className={"mb-3 same-height-container " + className}>
                      <CardRegimenHE
                        regimenLaboralProy={regimen}
                        index={index}
                      />
                    </Col>
                  )
                })}
              </Row>
            </Col>
          </Row>




          <Tabs
            id="tabProyecciones"
            defaultActiveKey={activeTab}
            // defaultActiveKey="Otras"
            className='tab_Planificacion_HE'
            onSelect={handleTabChange}
          >
            <Tab
              eventKey="Actividades" title="PROYECTAR POR ACTIVIDAD" className='tab_Planificacion_HE'
            >
              {loadingActyServ && <Cargando />}

              {!loadingActyServ && informacionGeneralProyeccion && listadoServyAct &&
                <ActividadProyeccionHE
                  regimenLaborales={informacionGeneralProyeccion.listadoRegimenLaborales}
                  listadoServidores={listadoServyAct.listadoServidores}
                  // recargarInformacion={ConsultarDetalleProyeccionesYActividades}
                  recargarInformacion={ObtenerInformacion}

                  actividadSeleccionadaEditar={actividadSeleccionada}
                  paramsProyeccionHE={informacionGeneralProyeccion.parametrosProyeccion}
                  detalleActividadPlanHEDTOs={listadoServyAct.detalleActividadProyHEDTOs}
                  idProyeccionUnidad={informacionGeneralProyeccion.idProyUnidadAnio}
                  //={informacionGeneralPlanificacion.refPlanifUnidad}
                  idSolicitudReverso={informacionGeneralProyeccion.idSolReverso}
                  estadoProyeccion={informacionGeneralProyeccion.estadoProyUnidad}
                  mensajeNovedad={informacionGeneralProyeccion.mensajeError}
                  gruposActividad={informacionGeneralProyeccion.gruposActividad}
                  idEstructura={informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion}

                  puedeRealizarAccion={informacionGeneralProyeccion.puedeRealizarAccion}
                  mostrarFirmaryEnviar={mostrarBotonFirmarEnviar}
                  mostrarGuardarParcial={mostrarBotonGuardar}
                  mostrarSolicitarReverso={mostrarBotonSolicitarReverso}

                  solicitarReverso={() => handleSolicitarReverso(informacionGeneralProyeccion.idProyUnidadAnio)}

                  guardarParcial={() => handleSubmit(informacionGeneralProyeccion, listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'GP')}
                  enviarTh={() => handleSubmit(informacionGeneralProyeccion, listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'ET')}

                  descargarResumenExcel={() => ReporteExcel()}
                  mostrarReporteResumenProyPlanifExcel={true}


                />
              }
            </Tab>
            <Tab
              eventKey="Servidores" title="PROYECTAR POR SERVIDOR" className='tab_Planificacion_HE'
            >
              {loadingActyServ && <Cargando />}
              {!loadingActyServ && informacionGeneralProyeccion && listadoServyAct &&
                <ServidoresProyeccionHE
                  listadoServidores={listadoServyAct.listadoServidores}
                  idUnidadAprueba={informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion}
                  nombreUnidadAprueba={informacionGeneralProyeccion.nombreUnidadAprobacion}
                  // recargarInformacion={ConsultarDetalleProyeccionesYActividades}
                  recargarInformacion={ObtenerInformacion}
                  parametrosHorasRegimenProyeccion={informacionGeneralProyeccion.parametrosProyeccion}
                  novedadesServidores={informacionGeneralProyeccion.novedadesServidores}
                  estadoPlanificacion={informacionGeneralProyeccion.estadoProyUnidad ?? ""}
                  mensajeNovedad={informacionGeneralProyeccion.mensajeError}

                  puedeRealizarAccion={informacionGeneralProyeccion.puedeRealizarAccion}
                  mostrarFirmaryEnviar={mostrarBotonFirmarEnviar}
                  mostrarGuardarParcial={mostrarBotonGuardar}
                  mostrarSolicitarReverso={mostrarBotonSolicitarReverso}

                  solicitarReverso={() => handleSolicitarReverso(informacionGeneralProyeccion.idProyUnidadAnio)}

                  guardarParcial={() => handleSubmit(informacionGeneralProyeccion, listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'GP')}
                  enviarTh={() => handleSubmit(informacionGeneralProyeccion, listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'ET')}

                  descargarResumenExcel={() => ReporteExcel()}
                  mostrarReporteResumenProyPlanifExcel={true}
                  gruposActividad={informacionGeneralProyeccion.gruposActividad}

                />
              }


            </Tab>
            <Tab
              eventKey="Otras" title="PROYECTAR A SERVIDOR DE OTRA UNIDAD" className='tab_Planificacion_HE'
            >
              {
                informacionGeneralProyeccion && listadoServyAct &&
                <TabOtrasUnidades
                  listadoServidoresOtrasUnidades={listadoServyAct.listadoServidoresOtrasUnidades}
                  idUnidadAprueba={informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion}
                  nombreUnidadAprueba={informacionGeneralProyeccion.nombreUnidadAprobacion}
                  novedadesServidores={informacionGeneralProyeccion.novedadesServidores}
                  estadoProyeccion={informacionGeneralProyeccion.estadoProyUnidad ?? ""}
                  mensajeNovedad={informacionGeneralProyeccion.mensajeError}
                  parametrosHorasRegimenProyeccion={informacionGeneralProyeccion.parametrosProyeccion}
                  // recargarInformacion={ConsultarDetalleProyeccionesYActividades}
                  recargarInformacion={ObtenerInformacion}

                  puedeRealizarAccion={informacionGeneralProyeccion.puedeRealizarAccion}
                  mostrarFirmaryEnviar={mostrarBotonFirmarEnviar}
                  mostrarGuardarParcial={mostrarBotonGuardar}
                  mostrarSolicitarReverso={mostrarBotonSolicitarReverso}

                  solicitarReverso={() => handleSolicitarReverso(informacionGeneralProyeccion.idProyUnidadAnio)}

                  guardarParcial={() => handleSubmit(informacionGeneralProyeccion, listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'GP')}
                  enviarTh={() => handleSubmit(informacionGeneralProyeccion, listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'ET')}


                  descargarResumenExcel={() => ReporteExcel()}
                  mostrarReporteResumenProyPlanifExcel={true}
                  gruposActividad={informacionGeneralProyeccion.gruposActividad}
                />
              }


            </Tab>

          </Tabs>


          {/* <Row className="justify-content-end row-no-margin">
            {listadoServyAct && mostrarBotonGuardar && informacionGeneralProyeccion && (
              <Col className="d-flex" md="auto">
                <Button className="btn-guardar" onClick={() => handleSubmit(listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'GP')}>
                  Guardar
                </Button>
              </Col>
            )}
            {
              listadoServyAct && mostrarBotonFirmarEnviar && informacionGeneralProyeccion && (
                <Col className="d-flex" md="auto">
                  <Button className="btn-guardar" onClick={() => handleSubmit(listadoServyAct, informacionGeneralProyeccion.informacionAprobador.idEstructuraOrganicaAprobacion, 'ET')}>
                    Enviar a TH
                  </Button>
                </Col>
              )
            }


          </Row> */}

          {
            modalConfirmacionProyeccion &&
            <ModalConfirmacionNew
              show={modalConfirmacionProyeccion.showModal}
              size="lg"
              onClose={() => {
                setModalConfirmacionProyeccion(undefined);
              }}
              asyncAccion={true}
              asyncClose={true}
              closeAfterAccion={true}
              hideBotonCerrar={false}
              mensajeConfirmacion={"¿Está seguro/a que desea guardar la siguiente proyección?"}
              nombreBotonAccion={"Aceptar"}
              nombreBotonCerrarModal={"Cancelar"}
              asyncOnClick={async () => await HandleGuardarProyeccion(modalConfirmacionProyeccion.solicitud)}
              contentModal={modalConfirmacionProyeccion.content}
              tituloModal={"Guardar proyección"}
              botonesAccionParteSuperior={true}
              iconModal={SaveSVG}
              classNamemensajeConfirmacion={"mensaje-confirmacion"}
            />
          }
          {
            modalConfirmacionEnvioTHProyeccion &&
            <ModalConfirmacion
              show={modalConfirmacionEnvioTHProyeccion.showModal}
              size="lg"
              onClose={() => {
                setmodalConfirmacionEnvioTHProyeccion(undefined);
              }}
              asyncAccion={true}
              asyncClose={true}
              closeAfterAccion={true}
              hideBotonCerrar={false}
              mensajeConfirmacion={""}
              nombreBotonAccion={"Aceptar"}
              nombreBotonCerrarModal={"Cancelar"}
              classNameBotonAccion="btnEspolPrimary"
              classNameBotonCerrarModal2={"btn-white-red"}
              asyncOnClick={async () => await EnviarProyeccionaTH(modalConfirmacionEnvioTHProyeccion.solicitud)}
              contentModal={modalConfirmacionEnvioTHProyeccion.content}
              tituloModal={""}
              invertOrderButton={true}
              botonesAccionParteSuperior={false}
              //iconModal={SaveSVG}
              classNamemensajeConfirmacion={"mensaje-confirmacion"}
            />
          }
          {/* {
            modalConfirmacionEnvioTHProyeccion &&
            <ModalConfirmacionNew
              show={modalConfirmacionEnvioTHProyeccion.showModal}
              size="lg"
              onClose={() => {
                setmodalConfirmacionEnvioTHProyeccion(undefined);
              }}
              asyncAccion={true}
              asyncClose={true}
              closeAfterAccion={true}
              hideBotonCerrar={false}
              mensajeConfirmacion={"¿Está seguro/a que desea enviar la siguiente proyección a TH?"}
              nombreBotonAccion={"Aceptar"}
              nombreBotonCerrarModal={"Cancelar"}
              asyncOnClick={async () => await EnviarProyeccionaTH(modalConfirmacionEnvioTHProyeccion.solicitud)}
              contentModal={modalConfirmacionEnvioTHProyeccion.content}
              tituloModal={"Enviar proyección"}
              botonesAccionParteSuperior={true}
              iconModal={SaveSVG}
              classNamemensajeConfirmacion={"mensaje-confirmacion"}
            />
          } */}
          {/* {
            modalSolicitarReverso &&
            <ModalReversoHE
              show={modalSolicitarReverso !== undefined}
              size="lg"
              onClose={() => setmodalSolicitarReverso(undefined)}
              asyncAccion={true}
              asyncClose={true}
              closeAfterAccion={true}
              hideBotonCerrar={false}
              mensajeConfirmacion={"¿Está seguro/a que desea solicitar el reverso de la proyección?"}
              nombreBotonAccion={"SI"}
              nombreBotonCerrarModal={"NO"}
              asyncOnClick={(observacion) => SolicitarReversoATH(modalSolicitarReverso.idProyeccionUnidad, { Observacion: observacion })}
              contentModal={undefined}
              tituloModal={"Solicitar reverso de la proyección de la unidad"}
              labelObservacion={"Indique el motivo de la solicitud"}
              botonesAccionParteSuperior={true}
              classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
              maxLength={500}

            />
          } */}
          {
            modalSolicitarReverso &&
            <ModalConfirmacion
              idModal='ModalReversoUnidadesTHHE'
              backdrop={false}
              show={modalSolicitarReverso !== undefined}
              size='lg'
              centered={true}
              asyncAccion={true}
              asyncClose={false}
              closeAfterAccion={true}
              hideBotonCerrar={true}
              mensajeConfirmacion=''
              nombreBotonAccion='Aceptar'
              classNameBotonAccion='btn-primary-new btnAceptarModalReversoTHHE'
              disabledBotonAccion={!motivoReverso}
              // <Button  className = "btn-primary-new" color="primary" title="Asignar Servidores" onClick={toggleModal}>Asignar a:</Button>
              onClose={() => { setmodalSolicitarReverso(undefined); setmotivoReverso("") }}
              asyncOnClick={() => SolicitarReversoATH(modalSolicitarReverso.idProyeccionUnidad, { Observacion: motivoReverso })}
              contentModal={contenidoModalReversarUnidad}
              classNameContentModal='modalContentReversoTHHE'
              tituloModal={"Solicitud reverso"}
              classNametituloModal=''
            />
          }
          {
            <ModalConfirmacion
              show={personalNoProyectado.length > 0}
              size='lg'
              centered={true}
              asyncAccion={false}
              asyncClose={false}
              closeAfterAccion={true}
              hideBotonCerrar={true}
              mensajeConfirmacion=''
              nombreBotonAccion='Aceptar'
              classNameBotonAccion='btn-primary-new'
              onClose={() => setpersonalNoProyectado([])}
              contentModal={GetHTMLPersonalNoProyectado(personalNoProyectado)}
              tituloModal={"Personal no Proyectado"}
            />
          }




          <ModalCargando
            show={loadingAccion}
            onClose={() => setloadingAccion(false)}
            size='md'
          />

        </React.Fragment>
      }





    </div>
  )
}
